import { colors } from './colors'

export const MuiCssBaseline = {
  styleOverrides: {
    html: {
      scrollBehavior: 'smooth',
      // fontSize here is to scale texts correctly on different screens
      fontSize: '10px',
      '@media (max-width: 900px)': {
        fontSize: '9.25px',
      },
      '@media (max-width: 600px)': {
        fontSize: '8.75px',
      },
      '& *': {
        scrollbarWidth: 'thin',
        scrollbarColor: `${colors.grey![500]} ${colors.grey![200]}`,
      },
      '& *::-webkit-scrollbar': {
        width: '.4rem',
        height: '.4rem',
      },
      '& *::-webkit-scrollbar-track': {
        background: colors.grey![200],
        borderRadius: '.8rem',
      },
      '& *::-webkit-scrollbar-thumb': {
        backgroundColor: colors.grey![500],
        borderRadius: '.8rem',
      },
      '& *:focus-visible': {
        // @ts-expect-error due to some MUI limitations
        outline: `2px solid ${colors.primary!.main}`,
        borderRadius: '.4rem',
        outlineOffset: 2,
      },
    },
  },
}
